const removePortFromUrl = (url: string): string => {
  try {
    const urlObject = new URL(url);
    urlObject.port = '';
    return urlObject.href.endsWith('/') ? urlObject.href.slice(0, -1) : urlObject.href;
  } catch (error) {
    console.error('Invalid URL:', url, error);
    return url;
  }
};

export default removePortFromUrl;
